import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiUser, FiSettings, FiLogOut } from "react-icons/fi";

import "../styles/Nav.css";
import NotificationDropdown from "./NotificationDropdown";
import { useSelector } from "react-redux";

const getTitle = (path) => {
  const titles = {
    home: "Home",
    projects: "Projects",
    project: "Project",
    dashboard: "Dashboard",
    expenses: "Expenses",
    leave: "Leave",
    clients: "Clients",
    employees: "Employees",
    employee: "Employee Profile",
    invoices: "Invoices",
    settings: "Settings",
    "my-timesheet": "My Timesheet",
    profile: "My Profile",
  };
  return titles[path] || "Dashboard";
};

function Nav({ pathName }) {
  const [searchQuery, setSearchQuery] = useState("");
  const pathname = useLocation().pathname.split("/")[1];
  //console.log(pathname);

  const [showNotifications, setShowNotifications] = useState(false);
  const notifRef = useRef();

  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileRef = useRef();

  const navigate = useNavigate();

  // const handleSearchChange = (e) => setSearchQuery(e.target.value);
  // const handleSearchSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Search Query:", searchQuery);
  // };

  useEffect(() => {
    function handleClickOutside(event) {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 const firstName = useSelector(_=>_?.login?.user?.first_name)
 const LastName = useSelector(_=>_?.login?.user?.last_name)


 
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
     localStorage.removeItem("userData");
                    localStorage.removeItem("userDetails");
                    localStorage.removeItem("builtPermissionsV1");
    navigate('/login');
    console.log("Logging out...");
  };

  return (
    <>
      <nav className="main-nav navbar navbar-expand-lg bg-white">
        <div className="container-fluid d-flex align-items-center justify-content-between">
          {/* <i class="bi bi-chevron-left fs-4"></i> */}
          <span className="navbar-brand fs-4 fw-bold nav-title" to={pathname}>
            {pathName ? pathName : getTitle(pathname)}
          </span>

          <ul className="navbar-nav d-flex flex-row align-items-center nav-actions ms-auto">
            {/* <li className="nav-item me-3">
              <Link to="/Addproject" className="nav-link">
                <div className="icon-circle bg-primary text-white">
                  <AiOutlinePlus size={24} />
                </div>
              </Link>
            </li> */}

            {/* <li className="nav-item me-3">
              <form className="search-form" onSubmit={handleSearchSubmit}>
                <button type="submit" className="search-btn">
                  <BiSearch size={18} />
                </button>
                <input
                  type="text"
                  placeholder="Search for something"
                  className="form-control search-input"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </form>
            </li> */}

            {/* <NotificationDropdown /> */}

            <li className="nav-item position-relative" ref={profileRef}>
              <div
                className="nav-link"
                style={{ cursor: "pointer" }}
                onClick={() => setShowProfileDropdown((prev) => !prev)}
              >
                <span className="me-2 small">{`${firstName} ${LastName}`}</span>
                <div className="profile-pic">
                  <img src="/assets/images/default-profile.jpg" alt="Profile" />
                </div>
              </div>
              {showProfileDropdown && (
                <div
                  className="dropdown-menu show"
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    minWidth: "170px",
                    background: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    borderRadius: "8px",
                    zIndex: 1000,
                    padding: "8px 0",
                  }}
                >
                  <Link
                    className="dropdown-item d-flex align-items-center"
                    to="/profile"
                  >
                    <FiUser className="me-2" /> My Profile
                  </Link>
                  <Link
                    className="dropdown-item d-flex align-items-center"
                    to="/settings"
                  >
                    <FiSettings className="me-2" /> Settings
                  </Link>
                  <div
                    className="dropdown-divider"
                    style={{ margin: "4px 0" }}
                  ></div>
                  <button
                    className="dropdown-item d-flex align-items-center"
                    style={{ cursor: "pointer", background: "none", border: "none", width: "100%" }}
                    onClick={handleLogout}
                  >
                    <FiLogOut className="me-2" /> Logout
                  </button>
                </div>
              )}
            </li>
          </ul>
        </div>
      </nav>

      <hr className="m-0 nav-divider" />
    </>
  );
}

export default Nav;

// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";  // Import useLocation
// import { AiOutlinePlus } from "react-icons/ai";
// import { BiSearch } from "react-icons/bi";
// import { FiBell } from "react-icons/fi";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import AddProject from "../pages/Addproject";

// // Helper function to get the page title based on the route
// const getTitle = (path) => {
//   const titles = {
//     "/home": "Home",
//     "/projects": "Projects",
//     "/dashboard": "Dashboard",
//     "/expenses": "Expenses",
//     "/leave": "Leave",
//     "/companies": "Companies",
//     "/Employee": "Employees",
//   };
//   return titles[path] ;  // Default to "Projects"
// };

// function Nav() {
//   const [searchQuery, setSearchQuery] = useState("");
//   const { pathname } = useLocation();  // Access the current pathname directly

//   // Handle search input changes
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Handle search form submission
//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     console.log("Search Query:", searchQuery);
//   };

//   return (
//     <>
//       <nav className="navbar navbar-expand-lg navbar-light bg-white">
//         <div className="container-fluid">
//           {/* Render the title dynamically based on the current route */}
//           <Link className="navbar-brand fs-1 fw-bold" to={pathname}>
//             {getTitle(pathname)}  {/* Title changes dynamically */}
//           </Link>

//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex align-items-center">
//               {/* Add Project Button */}
//               <li className="nav-item me-3">
//                 <Link className="nav-link active" to="/Addproject">
//                   <div className="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white shadow-sm" style={{ width: "40px", height: "40px" }}>
//                     <AiOutlinePlus size={24} />
//                   </div>
//                 </Link>
//               </li>

//               {/* Search Bar */}
//               <li className="nav-item me-3">
//                 <form className="d-flex position-relative w-100" onSubmit={handleSearchSubmit}>
//                   <button
//                     type="submit"
//                     className="btn position-absolute top-50 start-0 translate-middle-y border-0 bg-transparent"
//                   >
//                     <BiSearch size={18} color="gray" />
//                   </button>
//                   <input
//                     type="text"
//                     className="form-control rounded-pill ps-5"
//                     placeholder="Search for something"
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                   />
//                 </form>
//               </li>

//               {/* Notifications Icon */}
//               <li className="nav-item me-3">
//                 <Link className="nav-link active" to="/notifications">
//                   <div className="position-relative d-flex justify-content-center align-items-center bg-white rounded-circle border border-pink" style={{ width: "35px", height: "35px" }}>
//                     <FiBell size={20} color="pink" />
//                     <span className="position-absolute top-0 end-0 rounded-circle bg-danger" style={{ width: "8px", height: "8px", border: "2px solid white" }} />
//                   </div>
//                 </Link>
//               </li>

//               {/* Profile Icon */}
//               <li className="nav-item">
//                 <Link className="nav-link active" to="/profile">
//                   <div className="rounded-circle overflow-hidden" style={{ width: "40px", height: "40px" }}>
//                     <img
//                       src="11.jpeg"
//                       alt="Profile"
//                       className="w-100 h-100 object-fit-cover"
//                     />
//                   </div>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       {/* Horizontal grey line below the navbar */}
//       <hr className="m-0" style={{ borderColor: "gray" }} />
//     </>
//   );
// }

// export default Nav;
